// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__uu3CN","head":"ProcedureTableInfo_head__1zmC2"};